import { request } from '@umijs/max';

export interface SystemSettings {
  siteName: string;
  siteDescription: string;
  contactEmail: string;
  contactPhone: string;
  maxOrdersPerUser: number;
  defaultOrderPrice: number;
  enableEmailNotification: boolean;
  enableSmsNotification: boolean;
  enableAutoReview: boolean;
  maintenanceMode: boolean;
}

// 默认设置
const defaultSettings: SystemSettings = {
  siteName: '查新服务系统',
  siteDescription: '专业的科技查新和查收查引服务平台',
  contactEmail: 'admin@chaxin.com',
  contactPhone: '0571-12345678',
  maxOrdersPerUser: 10,
  defaultOrderPrice: 820,
  enableEmailNotification: true,
  enableSmsNotification: false,
  enableAutoReview: false,
  maintenanceMode: false,
};

// 缓存的设置
let cachedSettings: SystemSettings | null = null;

// 获取公开设置（不需要认证）
export const getPublicSettings = async (): Promise<Partial<SystemSettings>> => {
  try {
    const response = await request('/api/settings/public', {
      method: 'GET'
    });
    
    if (response.success) {
      return response.data;
    }
  } catch (error) {
    console.error('获取公开设置失败:', error);
  }
  
  // 返回默认设置
  return {
    siteName: defaultSettings.siteName,
    siteDescription: defaultSettings.siteDescription,
    contactEmail: defaultSettings.contactEmail,
    contactPhone: defaultSettings.contactPhone,
  };
};

// 获取所有设置（需要认证）
export const getAllSettings = async (): Promise<SystemSettings> => {
  try {
    const response = await request('/api/settings', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('chaxin_access_token')}`
      }
    });
    
    if (response.success) {
      // 转换数据类型
      const settings = { ...defaultSettings, ...response.data };
      Object.keys(settings).forEach(key => {
        if (settings[key] === 'true') settings[key] = true;
        if (settings[key] === 'false') settings[key] = false;
        if (!isNaN(Number(settings[key])) && settings[key] !== '') {
          settings[key] = Number(settings[key]);
        }
      });
      
      cachedSettings = settings as SystemSettings;
      return cachedSettings;
    }
  } catch (error) {
    console.error('获取设置失败:', error);
  }
  
  return defaultSettings;
};

// 获取缓存的设置
export const getCachedSettings = (): SystemSettings => {
  return cachedSettings || defaultSettings;
};

// 清除缓存
export const clearSettingsCache = () => {
  cachedSettings = null;
};

// 监听设置更新事件
export const onSettingsUpdated = (callback: (settings: SystemSettings) => void) => {
  const handler = (event: CustomEvent) => {
    cachedSettings = { ...defaultSettings, ...event.detail };
    callback(cachedSettings!);
  };
  
  window.addEventListener('systemSettingsUpdated', handler as EventListener);
  
  // 返回清理函数
  return () => {
    window.removeEventListener('systemSettingsUpdated', handler as EventListener);
  };
}; 